import axios from "axios";
import { returnErrors, createMessage } from "./messages";
import {
	GENRE_UPDATED,
	LOGOUT,
	ONBOARDED,
	GENRE_UPDATE_FAIL,
	PROFESSION_UPDATED,
	LOGIN_SUCCESS,
	LOGIN_FAIL,
	AUTH_ERROR,
	USER_LOADED,
	USER_LOADING,
	REGISTER_FAIL,
	REGISTER_SUCCESS,
	PROFESSION_UPDATE_FAIL
} from "./types";

// CHECK TOKEN & LOAD USER
export const loadUser = () => (dispatch, getState) => {
	//User Loading
	dispatch({ type: USER_LOADING });
	// Get token from state
	const key = getState().auth.key;

	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// If token, add to headers config
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
		axios
			.get("https://api.whipafrica.com/v1/users/me/", config)
			.then((res) => {
				dispatch({
					type: USER_LOADED,
					payload: res.data.results
				});
				console.log(res.data.results);
			})
			.catch((err) => {
				dispatch(returnErrors(err?.response?.data, err?.response?.status));
				dispatch({
					type: AUTH_ERROR
				});
			});
	}
};
// // GET USER ID
// export const loadId = () => (dispatch, getState) => {
//     dispatch({type: USER_LOADING})
// }

// LOGIN USER
export const login = (email, password) => (dispatch) => {
	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// Request Body
	const body = JSON.stringify({ email, password });
	axios
		.post("https://api.whipafrica.com/v1/auth/login/", body, config)
		.then((res) => {
			dispatch({
				type: LOGIN_SUCCESS,
				payload: res.data
			});
			// dispatch(createMessage(res.data));
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
			dispatch({
				type: LOGIN_FAIL
			});
			console.log(err?.response);
		});
};
// REGISTER USER
export const register =
	({ email, name, country, password1, password2 }) =>
	(dispatch) => {
		// Headers
		const config = {
			headers: {
				"Content-Type": "application/json"
			}
		};

		// Request Body
		const body = JSON.stringify({ email, name, country, password1, password2 });

		axios
			.post("https://api.whipafrica.com/v1/auth/registration/", body, config)
			.then((res) => {
				dispatch({
					type: REGISTER_SUCCESS,
					payload: res.data
				});
				// dispatch(createMessage(res.data));
			})
			.catch((err) => {
				dispatch(returnErrors(err?.response?.data, err?.response?.status));
				dispatch({
					type: REGISTER_FAIL
				});
			});
	};
export const logout = () => (dispatch) => {
	console.log("Logout From Action");
	dispatch({ type: LOGOUT });
};
// PATCH UPDATE THE PROFILE PROFESSION
export const professionUpdateCall = (profession) => (dispatch, getState) => {
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	const key = getState().auth.key;
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const user = getState().auth.users;
	const body = { profession };
	axios
		.patch(user, body, config)
		.then((res) => {
			dispatch({
				type: PROFESSION_UPDATED,
				payload: res.data
			});
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
			dispatch({
				type: PROFESSION_UPDATE_FAIL
			});
		});
};
// PATCH UPDATE THE PROFILE GENRE
export const genreUpdateCall = (genre) => (dispatch, getState) => {
	// GENRE_UPDATED
	// GENRE_UPDATE_FAIL
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	const key = getState().auth.key;
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const user = getState().auth.users;
	const body = { genre };
	axios
		.patch(user, body, config)
		.then((res) => {
			dispatch({
				type: GENRE_UPDATED,
				payload: res.data
			});
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
			dispatch({
				type: GENRE_UPDATE_FAIL
			});
		});
};
// PATCH ONBOARDING BOOL
export const onBoardingCall = (is_onboarded) => (dispatch, getState) => {
	// ONBOARDED
	// GENRE_UPDATE_FAIL
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	const key = getState().auth.key;
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}
	const user = getState().auth.users;
	const body = { is_onboarded };
	axios
		.patch(user, body, config)
		.then((res) => {
			dispatch({
				type: ONBOARDED,
				payload: res.data
			});
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
			dispatch({
				type: GENRE_UPDATE_FAIL
			});
		});
};

export const resetPassword = (email) => (dispatch) => {
	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};

	// Request Body
	const body = new FormData();
	body.append("email", email);

	axios
		.post("https://api.whipafrica.com/v1/auth/password/reset/", body, config)
		.then((res) => {
			dispatch(createMessage(res.data.detail));
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
			dispatch({
				type: REGISTER_FAIL
			});
		});
};

export const changePassword = (data) => (dispatch, getState) => {
	// Headers
	const config = {
		headers: {
			"Content-Type": "application/json"
		}
	};
	const key = getState().auth.key;
	if (key) {
		config.headers["Authorization"] = `Token ${key}`;
	}

	axios
		.post("https://api.whipafrica.com/v1/auth/password/change/", data, config)
		.then((res) => {
			if (res) {
				dispatch(createMessage(res.data));
			}
		})
		.catch((err) => {
			dispatch(returnErrors(err?.response?.data, err?.response?.status));
		});
};
